import { BaseApi } from '@/shared/api/baseApi';
import { api } from '@/shared/api';
import { API_ENDPOINTS } from '@/constants/api';
import { normalizePaginatedResponse } from '@/shared/api/pagination';
import type { PaginatedApiResponse } from '@/shared/api/pagination';
import type { EntityListParams, PaginatedResponse } from '@/shared/types/entity';
import type { DSAgent, DSAgentFormData } from '../types';

const dsAgentsApiInstance = new BaseApi<DSAgent, DSAgentFormData>(API_ENDPOINTS.DS_AGENTS);

export const dsAgentsApi = {
  getList: async (params?: EntityListParams): Promise<PaginatedResponse<DSAgent>> => {
    const response = await api.get<PaginatedApiResponse<DSAgent>>(API_ENDPOINTS.DS_AGENTS.LIST, {
      params,
      skipLoader: true,
    });
    return normalizePaginatedResponse(response.data);
  },
  getOne: dsAgentsApiInstance.getOne.bind(dsAgentsApiInstance),
  create: dsAgentsApiInstance.create.bind(dsAgentsApiInstance),
  update: dsAgentsApiInstance.update.bind(dsAgentsApiInstance),
  delete: dsAgentsApiInstance.delete.bind(dsAgentsApiInstance),
};
